// Build/version string attached to feedback submissions for triage (L0-U6).
// Populated at build time via `VITE_APP_VERSION` (CI sets it to the release
// tag / git sha). When unset -- local dev, tests -- it falls back to a mode
// marker so the field is always a meaningful non-empty string.
export function appVersion(): string {
  const injected = import.meta.env.VITE_APP_VERSION;
  if (typeof injected === "string" && injected.length > 0) {
    return injected;
  }
  return `dev-${import.meta.env.MODE}`;
}
